/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface ErrorMessage {
    /** @minLength 1 */
    code: string;
    arguments: object[];
    /** @minLength 1 */
    defaultMessage: string;
}

export interface ErrorResponse {
    /** @minLength 1 */
    code: string;
    message: ErrorMessage;
    /** @minLength 1 */
    traceId: string;
    /** @deprecated */
    errorMessage?: string;
    defaultMessage?: string;
}

export interface UpdateUserTypeSupportDto {
    /** UserType */
    userType: 'USER' | 'COACH' | 'SUPPORT';
}

export interface UserEmailDto {
    /** @minLength 1 */
    value: string;
    main: boolean;
    verified: boolean;
}

export interface UserSearchSupportDto {
    /** @format int64 */
    id: number;
    /** @uniqueItems true */
    emails: UserEmailDto[];
    /** @minLength 1 */
    profileId: string;
    /** @minLength 1 */
    firstName: string;
    /** @minLength 1 */
    lastName: string;
    /** UserType */
    userType: 'USER' | 'COACH' | 'SUPPORT';
    /** @minLength 1 */
    feedId: string;
    featureFlags?: Record<string, boolean>;
}

export interface UpdateUserFeatureFlagsDto {
    featureFlags: Record<string, boolean>;
}

export interface UserFeatureFlagsDto {
    featureFlags: Record<string, boolean>;
}

export interface UserAppStateDto {
    state: Record<string, object>;
}

export interface UserAppDto {
    app: string;
    userControlled?: boolean;
    /** @format date-time */
    enabledDate: string;
    /** @format date-time */
    disabledDate?: string;
    state: Record<string, object>;
}

export interface I18NText {
    en?: string;
    de?: string;
    pl?: string;
}

export interface UpdateCatalogAppDto {
    enabled?: boolean;
    name?: I18NText;
    description?: I18NText;
    /** AppCategory */
    category?: 'HABITS' | 'TRAINING' | 'EXPLORE' | 'SOCIAL';
}

export interface AppRatingStatsDto {
    /** @format double */
    average?: number;
    /** @format int64 */
    count?: number;
    histogram: number[];
}

export interface CatalogAppDto {
    app: string;
    enabled?: boolean;
    listed?: boolean;
    name?: I18NText;
    description?: I18NText;
    /** AppCategory */
    category?: 'HABITS' | 'TRAINING' | 'EXPLORE' | 'SOCIAL';
    rating: AppRatingStatsDto;
}

export interface AnnouncementRequest {
    /**
     * @minLength 0
     * @maxLength 255
     */
    title: string;
    /**
     * @minLength 0
     * @maxLength 5000
     */
    message: string;
    /** AnnouncementSeverity */
    severity: 'INFO' | 'WARNING' | 'CRITICAL';
    active?: boolean;
    /** @format date-time */
    activeFrom?: string;
    /** @format date-time */
    activeTo?: string;
}

export interface AnnouncementDto {
    /** @format int64 */
    id?: number;
    title?: string;
    message?: string;
    /** AnnouncementSeverity */
    severity?: 'INFO' | 'WARNING' | 'CRITICAL';
    active?: boolean;
    /** @format date-time */
    activeFrom?: string;
    /** @format date-time */
    activeTo?: string;
}

export interface DefaultSuccessDto {
    success: boolean;
}

export interface YearlySummarySupportRequestDto {
    userIds: number[];
    /** @format int32 */
    year: number;
    allUsers: boolean;
    shouldSendMail: boolean;
}

export interface CdnObjectDtoV2 {
    /** @minLength 1 */
    bucket: string;
    /** @minLength 1 */
    key: string;
}

export interface WorkoutHeartRateEntryDto {
    /** @format date-time */
    timestamp: string;
    /** @format int32 */
    value: number;
}

export interface WorkoutMetadataDto {
    wasInRestrictedArea?: boolean;
    /** @format double */
    minBatteryLevel?: number;
    customFields?: Record<string, object>;
}

export interface WorkoutPayloadDto {
    /** WorkoutType */
    workoutType?: 'CYCLING' | 'RUNNING' | 'HIKING' | 'OTHER';
    /** WorkoutTypeV2 */
    workoutTypeV2?:
        | 'RUNNING'
        | 'WALKING'
        | 'TREKKING'
        | 'HIKING'
        | 'TREADMILL'
        | 'NORDIC_WALKING'
        | 'CYCLING'
        | 'ELECTRIC_CYCLING'
        | 'INDOOR_CYCLING'
        | 'ROLLERBLADE'
        | 'SKATEBOARD'
        | 'SCOOTER'
        | 'WHEELCHAIR'
        | 'SKIING'
        | 'SNOWBOARDING'
        | 'SKATING'
        | 'SKI_TOURING'
        | 'CROSS_COUNTRY_SKIING'
        | 'BIATHLON'
        | 'SWIMMING'
        | 'ROWING'
        | 'SURFING'
        | 'SAILING'
        | 'STAND_UP_PADDLE'
        | 'FOOTBALL'
        | 'VOLLEYBALL'
        | 'BASKETBALL'
        | 'HANDBALL'
        | 'TRAINING'
        | 'DANCING'
        | 'MARTIAL_ARTS'
        | 'TENNIS'
        | 'SQUASH'
        | 'PADEL'
        | 'TABLE_TENNIS'
        | 'BADMINTON'
        | 'CLIMBING'
        | 'TREADMILL_TIME'
        | 'SWIMMING_TIME'
        | 'INDOOR_WALKING_TIME'
        | 'INDOOR_RUNNING_TIME'
        | 'INDOOR_CYCLING_TIME'
        | 'INDOOR_ROWING_TIME'
        | 'ELLIPTICAL'
        | 'STRENGTH'
        | 'HIIT'
        | 'CARDIO'
        | 'CROSSFIT'
        | 'YOGA'
        | 'PILATES'
        | 'STRETCHING'
        | 'AEROBIC'
        | 'ZUMBA'
        | 'AQUA_GYM'
        | 'GOLF'
        | 'HORSE_RIDING'
        | 'OTHER';
    rawWorkoutType?: string;
    /** WorkoutRecordingMethod */
    recordingMethod?: 'GEOFENCE' | 'GPS' | 'ACCELEROMETER' | 'BLUETOOTH';
    /** @uniqueItems true */
    sources: string[];
    /** @uniqueItems true */
    devices: string[];
    device?: string;
    dateTimeRange: ZonedDateTimeRangeDto;
    properties: WorkoutPropertiesDto;
    rawData?: string;
    gpx?: CdnObjectDtoV2;
    tcx?: CdnObjectDtoV2;
    fitFile?: CdnObjectDtoV2;
    mapImage?: CdnObjectDtoV2;
    activityImages?: CdnObjectDtoV2[];
    metadata?: WorkoutMetadataDto;
    startPosition?: WorkoutPositionDto;
    /** ActivityVisibility */
    visibility?: 'PUBLIC' | 'PRIVATE' | 'IN_APP';
}

export interface WorkoutPositionDto {
    /**
     * @format double
     * @min -90
     * @max 90
     */
    latitude: number;
    /**
     * @format double
     * @min -180
     * @max 180
     */
    longitude: number;
}

export interface WorkoutPropertiesDto {
    /** @format double */
    distance?: number;
    /**
     * @deprecated
     * @format double
     */
    elevation?: number;
    /** @format double */
    averageSpeed?: number;
    /** @format double */
    activityTime?: number;
    /** @format double */
    maximumSpeed?: number;
    /** @format double */
    averageHeartRate?: number;
    /** @format double */
    maximumHeartRate?: number;
    /** @format double */
    caloriesBurned?: number;
    /** @format double */
    elevationGain?: number;
    /** @format double */
    elevationLoss?: number;
    /** @format double */
    stepCount?: number;
    speedEntries: WorkoutSpeedEntryDto[];
    heartRateEntries?: WorkoutHeartRateEntryDto[];
    externalId?: string;
    /** @format int64 */
    facilityId?: number;
    /** CheckInType */
    checkInType?: 'PUBLIC' | 'PRIVATE';
    validationPhoto?: CdnObjectDtoV2;
}

export interface WorkoutReplayRequestDto {
    userId: string;
    /** FitnessApp */
    fitnessApp?:
        | 'STRAVA'
        | 'GARMIN'
        | 'FITBIT'
        | 'POLAR'
        | 'WITHINGS'
        | 'HUAWEI_HEALTH'
        | 'SUUNTO'
        | 'ZEPP'
        | 'GOOGLE_HEALTH'
        | 'MR_PEDOMETER'
        | 'MOVE_REPUBLIC'
        | 'GOOGLE_FIT'
        | 'HEALTH_CONNECT'
        | 'APPLE_HEALTH'
        | 'SAMSUNG_HEALTH';
    /** @minItems 1 */
    workouts: WorkoutPayloadDto[];
}

export interface WorkoutSpeedEntryDto {
    /** @format date-time */
    timestamp: string;
    /** @format date-time */
    startTime: string;
    /** @format date-time */
    endTime: string;
    /** @format double */
    value: number;
}

export interface ZonedDateTimeRangeDto {
    /** @format date-time */
    from: string;
    /** @format date-time */
    to: string;
    /**
     * @deprecated
     * @format date-time
     */
    startDateTime?: string;
    /**
     * @deprecated
     * @format date-time
     */
    endDateTime?: string;
}

export interface CreateSmartConnectOnboardingDto {
    name?: string;
    params: Record<string, string[]>;
}

export interface SmartConnectOnboardingDto {
    key?: string;
    name?: string;
    params?: Record<string, string[]>;
    /** @format date-time */
    createdDate?: string;
}

export interface StravaDeauthorizeSupportRequestDto {
    tokenIds: number[];
}

export interface FitbitSupportSyncRequestDto {
    /** @format date */
    date: string;
    /** @format int64 */
    userId?: number;
}

export interface FitbitRevokeResultDto {
    revoked: string[];
    notRevoked: string[];
    failed: string[];
}

export interface FitnessAppBackfillRequestDto {
    /** @uniqueItems true */
    userIds?: number[];
    /** @uniqueItems true */
    fitnessApps?: (
        | 'STRAVA'
        | 'GARMIN'
        | 'FITBIT'
        | 'POLAR'
        | 'WITHINGS'
        | 'HUAWEI_HEALTH'
        | 'SUUNTO'
        | 'ZEPP'
        | 'GOOGLE_HEALTH'
        | 'MR_PEDOMETER'
        | 'MOVE_REPUBLIC'
        | 'GOOGLE_FIT'
        | 'HEALTH_CONNECT'
        | 'APPLE_HEALTH'
        | 'SAMSUNG_HEALTH'
    )[];
    dateTimeRange: ZonedDateTimeRangeDto;
    steps?: boolean;
    workouts?: boolean;
    dryRun?: boolean;
    /** @format int32 */
    pageSize?: number;
    /** @format int32 */
    startPageInclusive?: number;
    /** @format int32 */
    endPageInclusive?: number;
    /** FitnessAppBackfillMode */
    mode?: 'PUSH' | 'PULL';
    /** FitnessAppStepsMode */
    stepsMode?: 'DAILY' | 'CHUNKED';
    /** FitnessAppWorkoutsMode */
    workoutsMode?: 'SUMMARY' | 'DETAILS';
    atLeastOneDataTypeSelected?: boolean;
    validDateTimeRange?: boolean;
    validPageRange?: boolean;
}

export interface DeadLetterQueueRetryRequestDto {
    /** @minLength 1 */
    deadLetterQueue: string;
}

export interface DeadLetterQueueRetryResultDto {
    /** @format int32 */
    movedMessages?: number;
    /** @format int64 */
    remainingMessages?: number;
}

export interface GarminBackfillRequestDto {
    dateTimeRangeDto: ZonedDateTimeRangeDto;
    /** @format int64 */
    userId: number;
    epochs: boolean;
    activities: boolean;
}

export interface CountryPublicDto {
    /** CountryCode */
    key:
        | 'UNDEFINED'
        | 'AC'
        | 'AD'
        | 'AE'
        | 'AF'
        | 'AG'
        | 'AI'
        | 'AL'
        | 'AM'
        | 'AN'
        | 'AO'
        | 'AQ'
        | 'AR'
        | 'AS'
        | 'AT'
        | 'AU'
        | 'AW'
        | 'AX'
        | 'AZ'
        | 'BA'
        | 'BB'
        | 'BD'
        | 'BE'
        | 'BF'
        | 'BG'
        | 'BH'
        | 'BI'
        | 'BJ'
        | 'BL'
        | 'BM'
        | 'BN'
        | 'BO'
        | 'BQ'
        | 'BR'
        | 'BS'
        | 'BT'
        | 'BU'
        | 'BV'
        | 'BW'
        | 'BY'
        | 'BZ'
        | 'CA'
        | 'CC'
        | 'CD'
        | 'CF'
        | 'CG'
        | 'CH'
        | 'CI'
        | 'CK'
        | 'CL'
        | 'CM'
        | 'CN'
        | 'CO'
        | 'CP'
        | 'CR'
        | 'CS'
        | 'CU'
        | 'CV'
        | 'CW'
        | 'CX'
        | 'CY'
        | 'CZ'
        | 'DE'
        | 'DG'
        | 'DJ'
        | 'DK'
        | 'DM'
        | 'DO'
        | 'DZ'
        | 'EA'
        | 'EC'
        | 'EE'
        | 'EG'
        | 'EH'
        | 'ER'
        | 'ES'
        | 'ET'
        | 'EU'
        | 'EZ'
        | 'FI'
        | 'FJ'
        | 'FK'
        | 'FM'
        | 'FO'
        | 'FR'
        | 'FX'
        | 'GA'
        | 'GB'
        | 'GD'
        | 'GE'
        | 'GF'
        | 'GG'
        | 'GH'
        | 'GI'
        | 'GL'
        | 'GM'
        | 'GN'
        | 'GP'
        | 'GQ'
        | 'GR'
        | 'GS'
        | 'GT'
        | 'GU'
        | 'GW'
        | 'GY'
        | 'HK'
        | 'HM'
        | 'HN'
        | 'HR'
        | 'HT'
        | 'HU'
        | 'IC'
        | 'ID'
        | 'IE'
        | 'IL'
        | 'IM'
        | 'IN'
        | 'IO'
        | 'IQ'
        | 'IR'
        | 'IS'
        | 'IT'
        | 'JE'
        | 'JM'
        | 'JO'
        | 'JP'
        | 'KE'
        | 'KG'
        | 'KH'
        | 'KI'
        | 'KM'
        | 'KN'
        | 'KP'
        | 'KR'
        | 'KW'
        | 'KY'
        | 'KZ'
        | 'LA'
        | 'LB'
        | 'LC'
        | 'LI'
        | 'LK'
        | 'LR'
        | 'LS'
        | 'LT'
        | 'LU'
        | 'LV'
        | 'LY'
        | 'MA'
        | 'MC'
        | 'MD'
        | 'ME'
        | 'MF'
        | 'MG'
        | 'MH'
        | 'MK'
        | 'ML'
        | 'MM'
        | 'MN'
        | 'MO'
        | 'MP'
        | 'MQ'
        | 'MR'
        | 'MS'
        | 'MT'
        | 'MU'
        | 'MV'
        | 'MW'
        | 'MX'
        | 'MY'
        | 'MZ'
        | 'NA'
        | 'NC'
        | 'NE'
        | 'NF'
        | 'NG'
        | 'NI'
        | 'NL'
        | 'NO'
        | 'NP'
        | 'NR'
        | 'NT'
        | 'NU'
        | 'NZ'
        | 'OM'
        | 'PA'
        | 'PE'
        | 'PF'
        | 'PG'
        | 'PH'
        | 'PK'
        | 'PL'
        | 'PM'
        | 'PN'
        | 'PR'
        | 'PS'
        | 'PT'
        | 'PW'
        | 'PY'
        | 'QA'
        | 'RE'
        | 'RO'
        | 'RS'
        | 'RU'
        | 'RW'
        | 'SA'
        | 'SB'
        | 'SC'
        | 'SD'
        | 'SE'
        | 'SF'
        | 'SG'
        | 'SH'
        | 'SI'
        | 'SJ'
        | 'SK'
        | 'SL'
        | 'SM'
        | 'SN'
        | 'SO'
        | 'SR'
        | 'SS'
        | 'ST'
        | 'SU'
        | 'SV'
        | 'SX'
        | 'SY'
        | 'SZ'
        | 'TA'
        | 'TC'
        | 'TD'
        | 'TF'
        | 'TG'
        | 'TH'
        | 'TJ'
        | 'TK'
        | 'TL'
        | 'TM'
        | 'TN'
        | 'TO'
        | 'TP'
        | 'TR'
        | 'TT'
        | 'TV'
        | 'TW'
        | 'TZ'
        | 'UA'
        | 'UG'
        | 'UK'
        | 'UM'
        | 'US'
        | 'UY'
        | 'UZ'
        | 'VA'
        | 'VC'
        | 'VE'
        | 'VG'
        | 'VI'
        | 'VN'
        | 'VU'
        | 'WF'
        | 'WS'
        | 'XI'
        | 'XU'
        | 'XK'
        | 'YE'
        | 'YT'
        | 'YU'
        | 'ZA'
        | 'ZM'
        | 'ZR'
        | 'ZW';
    value: string;
}

export interface MsPageUserSearchSupportDto {
    content: UserSearchSupportDto[];
    /** @format int32 */
    number: number;
    /** @format int32 */
    size: number;
    /** @format int32 */
    totalPages: number;
    /** @format int64 */
    totalElements: number;
}

export interface UserFitnessAppSupportDto {
    /** @format int64 */
    id: number;
    /** FitnessApp */
    fitnessApp:
        | 'STRAVA'
        | 'GARMIN'
        | 'FITBIT'
        | 'POLAR'
        | 'WITHINGS'
        | 'HUAWEI_HEALTH'
        | 'SUUNTO'
        | 'ZEPP'
        | 'GOOGLE_HEALTH'
        | 'MR_PEDOMETER'
        | 'MOVE_REPUBLIC'
        | 'GOOGLE_FIT'
        | 'HEALTH_CONNECT'
        | 'APPLE_HEALTH'
        | 'SAMSUNG_HEALTH';
    name: string;
    externalUserId?: string;
    /** @format date-time */
    tokenExpiresAt?: string;
    /** @format date-time */
    createdDate: string;
    /** @format date-time */
    deletedDate?: string;
}

export interface UserPushTokenSupportDto {
    /** @format int64 */
    id: number;
    token: string;
    /** PushTokenType */
    type: 'FIREBASE' | 'EXPO';
    timeZone?: string;
    /** @format date-time */
    lastConfirmedDate: string;
    /** @format date-time */
    createdDate: string;
    /** @format int64 */
    appInstallationId?: number;
}

export interface UserAppInstallationSupportDto {
    /** @format int64 */
    id: number;
    appId?: string;
    appVersion?: string;
    /** @format date-time */
    createdDate: string;
    /** @format date-time */
    modifiedDate: string;
}

export interface UserDeviceSupportDto {
    /** @format int64 */
    id: number;
    /** DevicePlatform */
    platform?: 'IOS' | 'ANDROID';
    manufacturer?: string;
    model?: string;
    name?: string;
    osVersion?: string;
    locale?: string;
    /** @format date-time */
    createdDate: string;
    /** @format date-time */
    modifiedDate: string;
    appInstallations: UserAppInstallationSupportDto[];
}

export interface DeadLetterQueueDto {
    name?: string;
    /** @format int64 */
    messageCount?: number;
}

export interface DailyActiveUsersDayDto {
    /** @format date */
    day?: string;
    /** @format int64 */
    userCount?: number;
}

export interface DailyActiveUsersOverviewDto {
    days?: DailyActiveUsersDayDto[];
    record?: DailyActiveUsersDayDto;
}

export interface CatalogAppFeedbackDto {
    /** @format int64 */
    id?: number;
    /** @format int64 */
    userId?: number;
    firstName?: string;
    lastName?: string;
    /** AppFeedbackKind */
    kind: 'IDEA' | 'PROBLEM' | 'OTHER';
    text: string;
    context: Record<string, string>;
    /** @format date-time */
    createdDate: string;
}

export interface MsPageCatalogAppFeedbackDto {
    content: CatalogAppFeedbackDto[];
    /** @format int32 */
    number: number;
    /** @format int32 */
    size: number;
    /** @format int32 */
    totalPages: number;
    /** @format int64 */
    totalElements: number;
}

export interface CatalogAppAccessDto {
    /** @format int64 */
    userId: number;
    firstName?: string;
    lastName?: string;
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, 'body' | 'bodyUsed'>;

export interface FullRequestParams extends Omit<RequestInit, 'body'> {
    /** set parameter to `true` for call `securityWorker` for this request */
    secure?: boolean;
    /** request path */
    path: string;
    /** content type of request body */
    type?: ContentType;
    /** query params */
    query?: QueryParamsType;
    /** format of response (i.e. response.json() -> format: "json") */
    format?: ResponseFormat;
    /** request body */
    body?: unknown;
    /** base url */
    baseUrl?: string;
    /** request cancellation token */
    cancelToken?: CancelToken;
}

export type RequestParams = Omit<
    FullRequestParams,
    'body' | 'method' | 'query' | 'path'
>;

export interface ApiConfig<SecurityDataType = unknown> {
    baseUrl?: string;
    baseApiParams?: Omit<RequestParams, 'baseUrl' | 'cancelToken' | 'signal'>;
    securityWorker?: (
        securityData: SecurityDataType | null
    ) => Promise<RequestParams | void> | RequestParams | void;
    customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown>
    extends Response {
    data: D;
    error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
    Json = 'application/json',
    FormData = 'multipart/form-data',
    UrlEncoded = 'application/x-www-form-urlencoded',
    Text = 'text/plain'
}

export class HttpClient<SecurityDataType = unknown> {
    public baseUrl: string = '/mobile-api';
    private securityData: SecurityDataType | null = null;
    private securityWorker?: ApiConfig<SecurityDataType>['securityWorker'];
    private abortControllers = new Map<CancelToken, AbortController>();
    private customFetch = (...fetchParams: Parameters<typeof fetch>) =>
        fetch(...fetchParams);

    private baseApiParams: RequestParams = {
        credentials: 'same-origin',
        headers: {},
        redirect: 'follow',
        referrerPolicy: 'no-referrer'
    };

    constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
        Object.assign(this, apiConfig);
    }

    public setSecurityData = (data: SecurityDataType | null) => {
        this.securityData = data;
    };

    protected encodeQueryParam(key: string, value: any) {
        const encodedKey = encodeURIComponent(key);
        return `${encodedKey}=${encodeURIComponent(typeof value === 'number' ? value : `${value}`)}`;
    }

    protected addQueryParam(query: QueryParamsType, key: string) {
        return this.encodeQueryParam(key, query[key]);
    }

    protected addArrayQueryParam(query: QueryParamsType, key: string) {
        const value = query[key];
        return value.map((v: any) => this.encodeQueryParam(key, v)).join('&');
    }

    protected toQueryString(rawQuery?: QueryParamsType): string {
        const query = rawQuery || {};
        const keys = Object.keys(query).filter(
            (key) => 'undefined' !== typeof query[key]
        );
        return keys
            .map((key) =>
                Array.isArray(query[key])
                    ? this.addArrayQueryParam(query, key)
                    : this.addQueryParam(query, key)
            )
            .join('&');
    }

    protected addQueryParams(rawQuery?: QueryParamsType): string {
        const queryString = this.toQueryString(rawQuery);
        return queryString ? `?${queryString}` : '';
    }

    private contentFormatters: Record<ContentType, (input: any) => any> = {
        [ContentType.Json]: (input: any) =>
            input !== null &&
            (typeof input === 'object' || typeof input === 'string')
                ? JSON.stringify(input)
                : input,
        [ContentType.Text]: (input: any) =>
            input !== null && typeof input !== 'string'
                ? JSON.stringify(input)
                : input,
        [ContentType.FormData]: (input: any) =>
            Object.keys(input || {}).reduce((formData, key) => {
                const property = input[key];
                formData.append(
                    key,
                    property instanceof Blob
                        ? property
                        : typeof property === 'object' && property !== null
                          ? JSON.stringify(property)
                          : `${property}`
                );
                return formData;
            }, new FormData()),
        [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input)
    };

    protected mergeRequestParams(
        params1: RequestParams,
        params2?: RequestParams
    ): RequestParams {
        return {
            ...this.baseApiParams,
            ...params1,
            ...(params2 || {}),
            headers: {
                ...(this.baseApiParams.headers || {}),
                ...(params1.headers || {}),
                ...((params2 && params2.headers) || {})
            }
        };
    }

    protected createAbortSignal = (
        cancelToken: CancelToken
    ): AbortSignal | undefined => {
        if (this.abortControllers.has(cancelToken)) {
            const abortController = this.abortControllers.get(cancelToken);
            if (abortController) {
                return abortController.signal;
            }
            return void 0;
        }

        const abortController = new AbortController();
        this.abortControllers.set(cancelToken, abortController);
        return abortController.signal;
    };

    public abortRequest = (cancelToken: CancelToken) => {
        const abortController = this.abortControllers.get(cancelToken);

        if (abortController) {
            abortController.abort();
            this.abortControllers.delete(cancelToken);
        }
    };

    public request = async <T = any, E = any>({
        body,
        secure,
        path,
        type,
        query,
        format,
        baseUrl,
        cancelToken,
        ...params
    }: FullRequestParams): Promise<HttpResponse<T, E>> => {
        const secureParams =
            ((typeof secure === 'boolean'
                ? secure
                : this.baseApiParams.secure) &&
                this.securityWorker &&
                (await this.securityWorker(this.securityData))) ||
            {};
        const requestParams = this.mergeRequestParams(params, secureParams);
        const queryString = query && this.toQueryString(query);
        const payloadFormatter =
            this.contentFormatters[type || ContentType.Json];
        const responseFormat = format || requestParams.format;

        return this.customFetch(
            `${baseUrl || this.baseUrl || ''}${path}${queryString ? `?${queryString}` : ''}`,
            {
                ...requestParams,
                headers: {
                    ...(requestParams.headers || {}),
                    ...(type && type !== ContentType.FormData
                        ? { 'Content-Type': type }
                        : {})
                },
                signal:
                    (cancelToken
                        ? this.createAbortSignal(cancelToken)
                        : requestParams.signal) || null,
                body:
                    typeof body === 'undefined' || body === null
                        ? null
                        : payloadFormatter(body)
            }
        ).then(async (response) => {
            const r = response.clone() as HttpResponse<T, E>;
            r.data = null as unknown as T;
            r.error = null as unknown as E;

            const data = !responseFormat
                ? r
                : await response[responseFormat]()
                      .then((data) => {
                          if (r.ok) {
                              r.data = data;
                          } else {
                              r.error = data;
                          }
                          return r;
                      })
                      .catch((e) => {
                          r.error = e;
                          return r;
                      });

            if (cancelToken) {
                this.abortControllers.delete(cancelToken);
            }

            if (!response.ok) throw data;
            return data;
        });
    };
}

/**
 * @title msr-mobile-api
 * @version 3.1.4145
 * @baseUrl /mobile-api
 */
export class Api<
    SecurityDataType extends unknown
> extends HttpClient<SecurityDataType> {
    logout = {
        /**
         * No description
         *
         * @tags authentication-controller
         * @name AuthenticationControllerLogout
         * @request POST:/logout
         * @secure
         */
        authenticationControllerLogout: (params: RequestParams = {}) =>
            this.request<void, void>({
                path: `/logout`,
                method: 'POST',
                secure: true,
                ...params
            })
    };
    supportApi = {
        /**
         * No description
         *
         * @tags user-search-support-controller
         * @name UserSearchSupportControllerUpdateUserType
         * @request PUT:/support-api/v1/users/{id}/type
         * @secure
         */
        userSearchSupportControllerUpdateUserType: (
            id: number,
            data: UpdateUserTypeSupportDto,
            params: RequestParams = {}
        ) =>
            this.request<UserSearchSupportDto, ErrorResponse>({
                path: `/support-api/v1/users/${id}/type`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags user-feature-flag-controller
         * @name UserFeatureFlagControllerUpdateFeatureFlags
         * @request PUT:/support-api/v1/users/{id}/feature-flags
         * @secure
         */
        userFeatureFlagControllerUpdateFeatureFlags: (
            id: number,
            data: UpdateUserFeatureFlagsDto,
            params: RequestParams = {}
        ) =>
            this.request<UserFeatureFlagsDto, ErrorResponse>({
                path: `/support-api/v1/users/${id}/feature-flags`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags user-app-support-controller
         * @name UserAppSupportControllerEnableUserApp
         * @request PUT:/support-api/v1/users/{id}/apps/{app}
         * @secure
         */
        userAppSupportControllerEnableUserApp: (
            id: number,
            app: string,
            data: UserAppStateDto,
            params: RequestParams = {}
        ) =>
            this.request<UserAppDto, ErrorResponse>({
                path: `/support-api/v1/users/${id}/apps/${app}`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags user-app-support-controller
         * @name UserAppSupportControllerDisableUserApp
         * @request DELETE:/support-api/v1/users/{id}/apps/{app}
         * @secure
         */
        userAppSupportControllerDisableUserApp: (
            id: number,
            app: string,
            params: RequestParams = {}
        ) =>
            this.request<void, ErrorResponse>({
                path: `/support-api/v1/users/${id}/apps/${app}`,
                method: 'DELETE',
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags user-app-support-controller
         * @name UserAppSupportControllerSetUserAppState
         * @request PUT:/support-api/v1/users/{id}/apps/{app}/state
         * @secure
         */
        userAppSupportControllerSetUserAppState: (
            id: number,
            app: string,
            data: UserAppStateDto,
            params: RequestParams = {}
        ) =>
            this.request<UserAppDto, ErrorResponse>({
                path: `/support-api/v1/users/${id}/apps/${app}/state`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags user-app-support-controller
         * @name UserAppSupportControllerGrantUserAppAccess
         * @request PUT:/support-api/v1/users/{id}/apps/{app}/access
         * @secure
         */
        userAppSupportControllerGrantUserAppAccess: (
            id: number,
            app: string,
            params: RequestParams = {}
        ) =>
            this.request<void, ErrorResponse>({
                path: `/support-api/v1/users/${id}/apps/${app}/access`,
                method: 'PUT',
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags user-app-support-controller
         * @name UserAppSupportControllerRevokeUserAppAccess
         * @request DELETE:/support-api/v1/users/{id}/apps/{app}/access
         * @secure
         */
        userAppSupportControllerRevokeUserAppAccess: (
            id: number,
            app: string,
            params: RequestParams = {}
        ) =>
            this.request<void, ErrorResponse>({
                path: `/support-api/v1/users/${id}/apps/${app}/access`,
                method: 'DELETE',
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags feature-toggle-support-controller
         * @name FeatureToggleSupportControllerGetGlobalFeatureFlags
         * @request GET:/support-api/v1/feature-flags
         * @secure
         */
        featureToggleSupportControllerGetGlobalFeatureFlags: (
            params: RequestParams = {}
        ) =>
            this.request<UserFeatureFlagsDto, ErrorResponse>({
                path: `/support-api/v1/feature-flags`,
                method: 'GET',
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags feature-toggle-support-controller
         * @name FeatureToggleSupportControllerUpdateGlobalFeatureFlags
         * @request PUT:/support-api/v1/feature-flags
         * @secure
         */
        featureToggleSupportControllerUpdateGlobalFeatureFlags: (
            data: UpdateUserFeatureFlagsDto,
            params: RequestParams = {}
        ) =>
            this.request<UserFeatureFlagsDto, ErrorResponse>({
                path: `/support-api/v1/feature-flags`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags catalog-app-support-controller
         * @name CatalogAppSupportControllerUpdateCatalogApp
         * @request PUT:/support-api/v1/apps/{app}
         * @secure
         */
        catalogAppSupportControllerUpdateCatalogApp: (
            app: string,
            data: UpdateCatalogAppDto,
            params: RequestParams = {}
        ) =>
            this.request<CatalogAppDto, ErrorResponse>({
                path: `/support-api/v1/apps/${app}`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags announcement-support-controller
         * @name AnnouncementSupportControllerGetAnnouncement
         * @request GET:/support-api/v1/announcements/{id}
         * @secure
         */
        announcementSupportControllerGetAnnouncement: (
            id: number,
            params: RequestParams = {}
        ) =>
            this.request<AnnouncementDto, ErrorResponse>({
                path: `/support-api/v1/announcements/${id}`,
                method: 'GET',
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags announcement-support-controller
         * @name AnnouncementSupportControllerUpdateAnnouncement
         * @request PUT:/support-api/v1/announcements/{id}
         * @secure
         */
        announcementSupportControllerUpdateAnnouncement: (
            id: number,
            data: AnnouncementRequest,
            params: RequestParams = {}
        ) =>
            this.request<AnnouncementDto, ErrorResponse>({
                path: `/support-api/v1/announcements/${id}`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags announcement-support-controller
         * @name AnnouncementSupportControllerDeleteAnnouncement
         * @request DELETE:/support-api/v1/announcements/{id}
         * @secure
         */
        announcementSupportControllerDeleteAnnouncement: (
            id: number,
            params: RequestParams = {}
        ) =>
            this.request<void, ErrorResponse>({
                path: `/support-api/v1/announcements/${id}`,
                method: 'DELETE',
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags strava-support-v-2-controller
         * @name StravaSupportV2ControllerSetupWebhooksSubscription
         * @request POST:/support-api/v2/fitness-apps/strava/webhooks/{publicFacilityGroup}
         * @secure
         */
        stravaSupportV2ControllerSetupWebhooksSubscription: (
            publicFacilityGroup: string,
            params: RequestParams = {}
        ) =>
            this.request<DefaultSuccessDto, ErrorResponse>({
                path: `/support-api/v2/fitness-apps/strava/webhooks/${publicFacilityGroup}`,
                method: 'POST',
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags yearly-summary-support-controller
         * @name YearlySummarySupportControllerGenerate
         * @request POST:/support-api/v1/yearly-summaries
         * @secure
         */
        yearlySummarySupportControllerGenerate: (
            data: YearlySummarySupportRequestDto,
            params: RequestParams = {}
        ) =>
            this.request<void, ErrorResponse>({
                path: `/support-api/v1/yearly-summaries`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags workout-replay-support-controller
         * @name WorkoutReplaySupportControllerReplay
         * @request POST:/support-api/v1/workout-replays
         * @secure
         */
        workoutReplaySupportControllerReplay: (
            data: WorkoutReplayRequestDto,
            params: RequestParams = {}
        ) =>
            this.request<void, ErrorResponse>({
                path: `/support-api/v1/workout-replays`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags smart-connect-onboarding-support-controller
         * @name SmartConnectOnboardingSupportControllerList
         * @request GET:/support-api/v1/smart-connect-onboardings
         * @secure
         */
        smartConnectOnboardingSupportControllerList: (
            params: RequestParams = {}
        ) =>
            this.request<SmartConnectOnboardingDto[], ErrorResponse>({
                path: `/support-api/v1/smart-connect-onboardings`,
                method: 'GET',
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags smart-connect-onboarding-support-controller
         * @name SmartConnectOnboardingSupportControllerCreate
         * @request POST:/support-api/v1/smart-connect-onboardings
         * @secure
         */
        smartConnectOnboardingSupportControllerCreate: (
            data: CreateSmartConnectOnboardingDto,
            params: RequestParams = {}
        ) =>
            this.request<SmartConnectOnboardingDto, ErrorResponse>({
                path: `/support-api/v1/smart-connect-onboardings`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags redis-session-index-cleanup-jobs-controller
         * @name RedisSessionIndexCleanupJobsControllerCleanUserAccountSessionIndex
         * @request POST:/support-api/v1/redis-session-index-cleanup
         * @secure
         */
        redisSessionIndexCleanupJobsControllerCleanUserAccountSessionIndex: (
            query: {
                /** @format int64 */
                userAccountId: number;
            },
            params: RequestParams = {}
        ) =>
            this.request<void, ErrorResponse>({
                path: `/support-api/v1/redis-session-index-cleanup`,
                method: 'POST',
                query: query,
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags promoter-connect-support-controller
         * @name PromoterConnectSupportControllerRestore
         * @request POST:/support-api/v1/promoter-connects/{id}/recover
         * @secure
         */
        promoterConnectSupportControllerRestore: (
            id: number,
            params: RequestParams = {}
        ) =>
            this.request<void, ErrorResponse>({
                path: `/support-api/v1/promoter-connects/${id}/recover`,
                method: 'POST',
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags profile-visibility-migration-controller
         * @name ProfileVisibilityMigrationControllerMigrateAllUsers
         * @request POST:/support-api/v1/profile-visibility-migration
         * @secure
         */
        profileVisibilityMigrationControllerMigrateAllUsers: (
            query?: {
                /**
                 * @format int64
                 * @min 0
                 * @default 50
                 */
                delayInMillis?: number;
            },
            params: RequestParams = {}
        ) =>
            this.request<void, ErrorResponse>({
                path: `/support-api/v1/profile-visibility-migration`,
                method: 'POST',
                query: query,
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags jobs-controller
         * @name JobsControllerTriggerJob
         * @request POST:/support-api/v1/jobs
         * @secure
         */
        jobsControllerTriggerJob: (
            query: {
                jobname: string;
                /** @default true */
                transactional?: boolean;
                tenant?: string;
                /** @format int32 */
                pageSize?: number;
                /** @format int32 */
                startPageInclusive?: number;
                /** @format int32 */
                endPageInclusive?: number;
            },
            params: RequestParams = {}
        ) =>
            this.request<string, ErrorResponse>({
                path: `/support-api/v1/jobs`,
                method: 'POST',
                query: query,
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags strava-support-controller
         * @name StravaSupportControllerSetupWebhooksSubscription
         * @request POST:/support-api/v1/fitness-apps/strava/webhooks
         * @secure
         */
        stravaSupportControllerSetupWebhooksSubscription: (
            params: RequestParams = {}
        ) =>
            this.request<DefaultSuccessDto, ErrorResponse>({
                path: `/support-api/v1/fitness-apps/strava/webhooks`,
                method: 'POST',
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags strava-support-controller
         * @name StravaSupportControllerDeauthorizeTokens
         * @request POST:/support-api/v1/fitness-apps/strava/deauthorize
         * @secure
         */
        stravaSupportControllerDeauthorizeTokens: (
            data: StravaDeauthorizeSupportRequestDto,
            params: RequestParams = {}
        ) =>
            this.request<void, ErrorResponse>({
                path: `/support-api/v1/fitness-apps/strava/deauthorize`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags fitbit-support-controller
         * @name FitbitSupportControllerSyncActivities
         * @request POST:/support-api/v1/fitness-apps/fitbit/sync
         * @secure
         */
        fitbitSupportControllerSyncActivities: (
            data: FitbitSupportSyncRequestDto,
            params: RequestParams = {}
        ) =>
            this.request<void, ErrorResponse>({
                path: `/support-api/v1/fitness-apps/fitbit/sync`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags fitbit-support-controller
         * @name FitbitSupportControllerRevokeUserTokens
         * @request POST:/support-api/v1/fitness-apps/fitbit/revoke-user-tokens
         * @secure
         */
        fitbitSupportControllerRevokeUserTokens: (
            data: string[],
            params: RequestParams = {}
        ) =>
            this.request<FitbitRevokeResultDto, ErrorResponse>({
                path: `/support-api/v1/fitness-apps/fitbit/revoke-user-tokens`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags fitness-app-backfill-support-controller
         * @name FitnessAppBackfillSupportControllerBackfill
         * @request POST:/support-api/v1/fitness-apps-backfills
         * @secure
         */
        fitnessAppBackfillSupportControllerBackfill: (
            data: FitnessAppBackfillRequestDto,
            params: RequestParams = {}
        ) =>
            this.request<void, ErrorResponse>({
                path: `/support-api/v1/fitness-apps-backfills`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags fill-additional-emails-jobs-controller
         * @name FillAdditionalEmailsJobsControllerTriggerJob
         * @request POST:/support-api/v1/fill-additional-emails-from-corporate
         * @secure
         */
        fillAdditionalEmailsJobsControllerTriggerJob: (
            params: RequestParams = {}
        ) =>
            this.request<void, ErrorResponse>({
                path: `/support-api/v1/fill-additional-emails-from-corporate`,
                method: 'POST',
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags fastrelay-feed-setup-controller
         * @name FastrelayFeedSetupControllerRequestSetUpForAllUsers
         * @request POST:/support-api/v1/fastrelay-feed-setup
         * @secure
         */
        fastrelayFeedSetupControllerRequestSetUpForAllUsers: (
            query?: {
                /**
                 * @format int32
                 * @exclusiveMin 0
                 */
                limit?: number;
            },
            params: RequestParams = {}
        ) =>
            this.request<void, ErrorResponse>({
                path: `/support-api/v1/fastrelay-feed-setup`,
                method: 'POST',
                query: query,
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags delete-redis-sessions-without-user-jobs-controller
         * @name DeleteRedisSessionsWithoutUserJobsControllerTriggerJob
         * @request POST:/support-api/v1/delete-redis-sessions-without-user/start
         * @secure
         */
        deleteRedisSessionsWithoutUserJobsControllerTriggerJob: (
            query: {
                /** @format int32 */
                scanSize: number;
                /** @format int32 */
                taskDelayInSeconds: number;
                dryRun: boolean;
            },
            params: RequestParams = {}
        ) =>
            this.request<void, ErrorResponse>({
                path: `/support-api/v1/delete-redis-sessions-without-user/start`,
                method: 'POST',
                query: query,
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags delete-redis-sessions-without-user-jobs-controller
         * @name DeleteRedisSessionsWithoutUserJobsControllerCancelJob
         * @request POST:/support-api/v1/delete-redis-sessions-without-user/cancel
         * @secure
         */
        deleteRedisSessionsWithoutUserJobsControllerCancelJob: (
            params: RequestParams = {}
        ) =>
            this.request<void, ErrorResponse>({
                path: `/support-api/v1/delete-redis-sessions-without-user/cancel`,
                method: 'POST',
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags delete-old-redis-sessions-jobs-controller
         * @name DeleteOldRedisSessionsJobsControllerTriggerJob
         * @request POST:/support-api/v1/delete-old-redis-sessions/start
         * @secure
         */
        deleteOldRedisSessionsJobsControllerTriggerJob: (
            query: {
                /** @format int32 */
                scanSize: number;
                /** @format int32 */
                taskDelayInSeconds: number;
                dryRun: boolean;
            },
            params: RequestParams = {}
        ) =>
            this.request<void, ErrorResponse>({
                path: `/support-api/v1/delete-old-redis-sessions/start`,
                method: 'POST',
                query: query,
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags delete-old-redis-sessions-jobs-controller
         * @name DeleteOldRedisSessionsJobsControllerCancelJob
         * @request POST:/support-api/v1/delete-old-redis-sessions/cancel
         * @secure
         */
        deleteOldRedisSessionsJobsControllerCancelJob: (
            params: RequestParams = {}
        ) =>
            this.request<void, ErrorResponse>({
                path: `/support-api/v1/delete-old-redis-sessions/cancel`,
                method: 'POST',
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags delete-invalid-redis-session-indexes-jobs-controller
         * @name DeleteInvalidRedisSessionIndexesJobsControllerTriggerJob
         * @request POST:/support-api/v1/delete-invalid-redis-sessions-indexes/start
         * @secure
         */
        deleteInvalidRedisSessionIndexesJobsControllerTriggerJob: (
            query: {
                /** @format int32 */
                scanSize: number;
                /** @format int32 */
                taskDelayInSeconds: number;
                dryRun: boolean;
            },
            params: RequestParams = {}
        ) =>
            this.request<void, ErrorResponse>({
                path: `/support-api/v1/delete-invalid-redis-sessions-indexes/start`,
                method: 'POST',
                query: query,
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags delete-invalid-redis-session-indexes-jobs-controller
         * @name DeleteInvalidRedisSessionIndexesJobsControllerCancelJob
         * @request POST:/support-api/v1/delete-invalid-redis-session-indexes/cancel
         * @secure
         */
        deleteInvalidRedisSessionIndexesJobsControllerCancelJob: (
            params: RequestParams = {}
        ) =>
            this.request<void, ErrorResponse>({
                path: `/support-api/v1/delete-invalid-redis-session-indexes/cancel`,
                method: 'POST',
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags dead-letter-queue-support-controller
         * @name DeadLetterQueueSupportControllerRetry
         * @request POST:/support-api/v1/dead-letter-queues/retries
         * @secure
         */
        deadLetterQueueSupportControllerRetry: (
            data: DeadLetterQueueRetryRequestDto,
            params: RequestParams = {}
        ) =>
            this.request<DeadLetterQueueRetryResultDto, ErrorResponse>({
                path: `/support-api/v1/dead-letter-queues/retries`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags announcement-support-controller
         * @name AnnouncementSupportControllerGetAllAnnouncements
         * @request GET:/support-api/v1/announcements
         * @secure
         */
        announcementSupportControllerGetAllAnnouncements: (
            params: RequestParams = {}
        ) =>
            this.request<AnnouncementDto[], ErrorResponse>({
                path: `/support-api/v1/announcements`,
                method: 'GET',
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags announcement-support-controller
         * @name AnnouncementSupportControllerCreateAnnouncement
         * @request POST:/support-api/v1/announcements
         * @secure
         */
        announcementSupportControllerCreateAnnouncement: (
            data: AnnouncementRequest,
            params: RequestParams = {}
        ) =>
            this.request<AnnouncementDto, ErrorResponse>({
                path: `/support-api/v1/announcements`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags support-controller
         * @name SupportControllerGetActiveSessions
         * @request POST:/support-api/v1/active-user-sessions
         * @secure
         */
        supportControllerGetActiveSessions: (
            query?: {
                /**
                 * @format int32
                 * @default 100
                 */
                size?: number;
            },
            params: RequestParams = {}
        ) =>
            this.request<string[], ErrorResponse>({
                path: `/support-api/v1/active-user-sessions`,
                method: 'POST',
                query: query,
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags user-search-support-controller
         * @name UserSearchSupportControllerSearchUsers
         * @request GET:/support-api/v1/users
         * @secure
         */
        userSearchSupportControllerSearchUsers: (
            query?: {
                search?: string;
                excludeFollowers?: boolean;
                excludeFollowed?: boolean;
                /** UserSearchMode */
                searchMode?: 'FRIENDS' | 'EVERYONE';
                /**
                 * @format int32
                 * @min 0
                 */
                page?: number;
                /**
                 * @format int32
                 * @exclusiveMin 0
                 * @max 100
                 */
                size?: number;
                sort?: string;
            },
            params: RequestParams = {}
        ) =>
            this.request<MsPageUserSearchSupportDto, ErrorResponse>({
                path: `/support-api/v1/users`,
                method: 'GET',
                query: query,
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags user-fitness-app-support-controller
         * @name UserFitnessAppSupportControllerGetConnections
         * @request GET:/support-api/v1/users/{userId}/fitness-apps
         * @secure
         */
        userFitnessAppSupportControllerGetConnections: (
            userId: number,
            params: RequestParams = {}
        ) =>
            this.request<UserFitnessAppSupportDto[], ErrorResponse>({
                path: `/support-api/v1/users/${userId}/fitness-apps`,
                method: 'GET',
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags user-search-support-controller
         * @name UserSearchSupportControllerGetUser
         * @request GET:/support-api/v1/users/{id}
         * @secure
         */
        userSearchSupportControllerGetUser: (
            id: number,
            params: RequestParams = {}
        ) =>
            this.request<UserSearchSupportDto, ErrorResponse>({
                path: `/support-api/v1/users/${id}`,
                method: 'GET',
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags user-push-token-support-controller
         * @name UserPushTokenSupportControllerGetUserPushTokens
         * @request GET:/support-api/v1/users/{id}/push-tokens
         * @secure
         */
        userPushTokenSupportControllerGetUserPushTokens: (
            id: number,
            params: RequestParams = {}
        ) =>
            this.request<UserPushTokenSupportDto[], ErrorResponse>({
                path: `/support-api/v1/users/${id}/push-tokens`,
                method: 'GET',
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags user-device-support-controller
         * @name UserDeviceSupportControllerGetUserDevices
         * @request GET:/support-api/v1/users/{id}/devices
         * @secure
         */
        userDeviceSupportControllerGetUserDevices: (
            id: number,
            params: RequestParams = {}
        ) =>
            this.request<UserDeviceSupportDto[], ErrorResponse>({
                path: `/support-api/v1/users/${id}/devices`,
                method: 'GET',
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags user-app-support-controller
         * @name UserAppSupportControllerGetUserApps
         * @request GET:/support-api/v1/users/{id}/apps
         * @secure
         */
        userAppSupportControllerGetUserApps: (
            id: number,
            params: RequestParams = {}
        ) =>
            this.request<UserAppDto[], ErrorResponse>({
                path: `/support-api/v1/users/${id}/apps`,
                method: 'GET',
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags user-app-support-controller
         * @name UserAppSupportControllerGetUserAppAccess
         * @request GET:/support-api/v1/users/{id}/apps/access
         * @secure
         */
        userAppSupportControllerGetUserAppAccess: (
            id: number,
            params: RequestParams = {}
        ) =>
            this.request<string[], ErrorResponse>({
                path: `/support-api/v1/users/${id}/apps/access`,
                method: 'GET',
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags smart-connect-onboarding-support-controller
         * @name SmartConnectOnboardingSupportControllerGetByKey
         * @request GET:/support-api/v1/smart-connect-onboardings/{key}
         * @secure
         */
        smartConnectOnboardingSupportControllerGetByKey: (
            key: string,
            params: RequestParams = {}
        ) =>
            this.request<SmartConnectOnboardingDto, ErrorResponse>({
                path: `/support-api/v1/smart-connect-onboardings/${key}`,
                method: 'GET',
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags dead-letter-queue-support-controller
         * @name DeadLetterQueueSupportControllerGetOverview
         * @request GET:/support-api/v1/dead-letter-queues
         * @secure
         */
        deadLetterQueueSupportControllerGetOverview: (
            params: RequestParams = {}
        ) =>
            this.request<DeadLetterQueueDto[], ErrorResponse>({
                path: `/support-api/v1/dead-letter-queues`,
                method: 'GET',
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags daily-active-users-support-controller
         * @name DailyActiveUsersSupportControllerGetOverview
         * @request GET:/support-api/v1/daily-active-users
         * @secure
         */
        dailyActiveUsersSupportControllerGetOverview: (
            params: RequestParams = {}
        ) =>
            this.request<DailyActiveUsersOverviewDto, ErrorResponse>({
                path: `/support-api/v1/daily-active-users`,
                method: 'GET',
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags catalog-app-support-controller
         * @name CatalogAppSupportControllerGetCatalogApps
         * @request GET:/support-api/v1/apps
         * @secure
         */
        catalogAppSupportControllerGetCatalogApps: (
            params: RequestParams = {}
        ) =>
            this.request<CatalogAppDto[], ErrorResponse>({
                path: `/support-api/v1/apps`,
                method: 'GET',
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags catalog-app-support-controller
         * @name CatalogAppSupportControllerGetCatalogAppFeedback
         * @request GET:/support-api/v1/apps/{app}/feedback
         * @secure
         */
        catalogAppSupportControllerGetCatalogAppFeedback: (
            app: string,
            query?: {
                /**
                 * @format int32
                 * @min 0
                 */
                page?: number;
                /**
                 * @format int32
                 * @exclusiveMin 0
                 * @max 100
                 */
                size?: number;
                sort?: string;
            },
            params: RequestParams = {}
        ) =>
            this.request<MsPageCatalogAppFeedbackDto, ErrorResponse>({
                path: `/support-api/v1/apps/${app}/feedback`,
                method: 'GET',
                query: query,
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags catalog-app-support-controller
         * @name CatalogAppSupportControllerGetCatalogAppAccess
         * @request GET:/support-api/v1/apps/{app}/access
         * @secure
         */
        catalogAppSupportControllerGetCatalogAppAccess: (
            app: string,
            params: RequestParams = {}
        ) =>
            this.request<CatalogAppAccessDto[], ErrorResponse>({
                path: `/support-api/v1/apps/${app}/access`,
                method: 'GET',
                secure: true,
                ...params
            })
    };
    internal = {
        /**
         * No description
         *
         * @tags garmin-backfill-internal-controller
         * @name GarminBackfillInternalControllerBackfill
         * @request POST:/internal/garmin-backfills
         * @secure
         */
        garminBackfillInternalControllerBackfill: (
            data: GarminBackfillRequestDto,
            params: RequestParams = {}
        ) =>
            this.request<void, ErrorResponse>({
                path: `/internal/garmin-backfills`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            })
    };
    v1 = {
        /**
         * No description
         *
         * @tags public-country-controller
         * @name PublicCountryControllerGetCountries
         * @request GET:/v1/public/countries
         * @secure
         */
        publicCountryControllerGetCountries: (params: RequestParams = {}) =>
            this.request<CountryPublicDto[], ErrorResponse>({
                path: `/v1/public/countries`,
                method: 'GET',
                secure: true,
                ...params
            })
    };
}
